import { MatDialog } from '@angular/material/dialog';
import { Observable, from, switchMap } from 'rxjs';

import type { Partner } from '@app/shared/_models/common';

// Fiche tiers en fenêtre, au triplet de QuotationComponent.openPartnerDialog ; rend le tiers relu (ou rien si fermée pendant le chargement).
// Import dynamique : la fiche importe app-search-partner, qui importe la liste des tiers (cycle, voir front.common.partners).
export function openPartnerSheet(dialog: MatDialog, id: number): Observable<Partner | null | undefined> {
  return from(import('@app/common/partner/partner.component')).pipe(
    switchMap(({ PartnerComponent }) => dialog.open(PartnerComponent, { width: '96%', height: '94%', maxWidth: '96vw', data: { mode: 'DIALOG', id } }).afterClosed()),
  );
}
